// Track the most recently viewed products (localStorage-backed).
// Vehicle-aware: when a vehicle is selected, we prefer items matching that brand's compatibility.
import { useEffect, useState } from "react";

const KEY = "uor_recently_viewed_v1";
const MAX = 12;
const listeners = new Set();

const read = () => {
    if (typeof window === "undefined") return [];
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const write = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    listeners.forEach((l) => l());
};

export const recentlyViewed = {
    push(product) {
        if (!product || !product.slug) return;
        const entry = {
            slug: product.slug,
            viewed_at: Date.now(),
            compatibility: product.compatibility || [],
        };
        const items = read().filter((i) => i.slug !== entry.slug);
        items.unshift(entry);
        write(items.slice(0, MAX));
    },
    get() { return read(); },
    clear() { write([]); },
};

// Returns the raw recent list. Filtering by brand is done by the consumer since
// products still need to be resolved server-side from slug.
export function useRecentlyViewed() {
    const [items, setItems] = useState(read());
    useEffect(() => {
        const cb = () => setItems(read());
        listeners.add(cb);
        return () => { listeners.delete(cb); };
    }, []);
    return items;
}
